import { configEnv } from '@libraries/config';

const seoConfig = {
  title: 'WMS PLN',
  description: 'Warehouse Management System PLN',
  openGraph: {
    type: 'website',
    locale: 'id_ID',
    url: configEnv.baseUrl,
    siteName: 'carte',
  },
  twitter: {
    handle: '@carte',
    site: '@carte',
    cardType: 'summary_large_image',
  },
};

export default seoConfig;
